export const removerAcentos = (texto) => {
  return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const removerAcentosECaracteresEspeciais = (texto) => {
  return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w-]+/g, ' ');
};